/* eslint-disable @typescript-eslint/naming-convention */
// IPA Tech First-Run "Get me ready for my day" (IP-16954).
// Contract: work-plans `ipa-tech-first-run-day-brief/contracts/first-run-v1.md` (A2, A7).
// Orchestrator first-run route (relative to orchestratorApiClient's baseURL).
export const FIRST_RUN_CHAT_PATH = '/chat/first-run';
export const DAY_BRIEF_PROTOCOL_VERSION = 1;
// Body `error` code of the 409 the route returns once the technician has
// deleted their first-run conversation. Nothing is recreated after that.
export const FIRST_RUN_CONVERSATION_DELETED = 'first_run_conversation_deleted';
export const DAY_BRIEF_FAILURE_REASON = {
    TEMPORARILY_UNAVAILABLE: 'temporarily_unavailable',
    NOT_ELIGIBLE: 'not_eligible',
    TERMS_REQUIRED: 'terms_required',
    REQUEST_REJECTED: 'request_rejected',
    UNSUPPORTED_PROTOCOL_VERSION: 'unsupported_protocol_version',
    INVALID_COMMAND: 'invalid_command',
    WIDGET_DISPOSED: 'widget_disposed'
};
// Stable id so a retried attempt replaces, rather than stacks, the error bubble.
export const DAY_BRIEF_ERROR_MESSAGE_ID = 'day-brief-error';
export const DAY_BRIEF_TRANSLATION_NAMESPACE = 'features.ai_chat_widget.day_brief';
// FR28: the footer "How to use IP Assistant" link sends exactly this text. The
// orchestrator answers a technician message whose normalised text equals it with
// a fixed, entitlement-filtered reply (no model call), so it must not be
// translated or reworded here. Typing it by hand behaves the same.
export const HOW_TO_USE_MESSAGE = 'How do I use IP Assistant?';
// FR21: the orchestrator persists this seed in English for every locale in v1, so
// the optimistic bubble must be the same string or it changes on history reload.
// Deliberately not a translation key.
export const DAY_BRIEF_SEED_MESSAGE = 'Get me ready for my day';
// English defaults for hosts that supply neither `window.I18n` nor a
// `translationOverrides` entry for these keys.
export const DAY_BRIEF_DEFAULT_TEXT = {
    error_retryable: "Sorry — I couldn't get your day ready just now. Please try again.",
    error_unavailable: "Your day brief isn't available right now. You can still ask me anything."
};
